import React from 'react';
import PropTypes from 'prop-types';
import { SimpleFlexbox } from '../../flexbox/flexbox';

/**
 * Render Product Additional Excess List Item
 * @param {String} label - The stateKey for the form
 * @param {String} amount - The excess amount
 * @return {Node} Additional Excess List Item
 */
const ProductAdditionalExcessListItem = ({ label, amount }) => {
    return (
        <SimpleFlexbox display="flex" contentBetween="xs">
            <p>{label}</p>
            <p>{amount}</p>
        </SimpleFlexbox>
    );
};

ProductAdditionalExcessListItem.propTypes = {
    label: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired
};

export { ProductAdditionalExcessListItem };
